import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class OrganisationKeysService {

  private static readonly _storageKey: string = 'organisation-key';

  constructor(private storageService: StorageService) {
  }

  public static get storageKey(): string {
    return OrganisationKeysService._storageKey;
  }

  public async setOrganisationKey(organisationKey: string): Promise<void> {
    await this.storageService.setItem(OrganisationKeysService._storageKey, organisationKey);
  }

  public async getOrganisationKey(): Promise<string> {
    return await this.storageService.getItem(OrganisationKeysService._storageKey);
  }

  public async removeOrganisationKey(): Promise<void> {
    await this.storageService.removeItem(OrganisationKeysService._storageKey);
  }
}
